import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner, Form, Button, Alert } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import ApiService from '../../services/ApiService';
import './Admin.css';

function Admin() {
  const [totalVentas, setTotalVentas] = useState(0);
  const [cantidadPedidos, setCantidadPedidos] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  // Establecer fechas por defecto: mes actual
  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    if (!dateFrom && !dateTo) {
      setDateFrom(formatDate(firstDay));
      setDateTo(formatDate(lastDay));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const loadTotalVentas = async () => {
      // Si no hay fechas, no hacer la petición
      if (!dateFrom || !dateTo) {
        setTotalVentas(0);
        setCantidadPedidos(0);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);
      
      try {
        const params = new URLSearchParams({
          desde: dateFrom,
          hasta: dateTo
        });
        
        const data = await ApiService.get(`/pedidos/ventas/total?${params.toString()}`);
        
        // El API devuelve { message, data: { totalVentas, cantidadPedidos, fechaDesde, fechaHasta } }
        const ventasData = data?.data || data;
        const total = Number(ventasData?.totalVentas || 0);
        const cantidad = Number(ventasData?.cantidadPedidos || 0);
        
        setTotalVentas(total);
        setCantidadPedidos(cantidad);
      } catch (err) {
        console.error('Error al obtener total de ventas:', err);
        setError(err?.message || 'Error al obtener el total de ventas');
        setTotalVentas(0);
        setCantidadPedidos(0);
      } finally {
        setLoading(false);
      }
    };

    loadTotalVentas();
  }, [dateFrom, dateTo]);

  const comisionHigher = totalVentas * 0.02;

  return (
    <div className="admin-page">
      <Row className="g-3">
        <Col xs={12} className="mb-2">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <small className="text-muted">Filtrar por fecha:</small>
            <Form.Control
              type="date"
              size="sm"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              style={{ maxWidth: 170 }}
              aria-label="Desde"
            />
            <span className="text-muted">—</span>
            <Form.Control
              type="date"
              size="sm"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              style={{ maxWidth: 170 }}
              aria-label="Hasta"
            />
            {(dateFrom || dateTo) && (
              <Button
                variant="link"
                size="sm"
                className="text-decoration-none p-1"
                onClick={() => { setDateFrom(''); setDateTo(''); }}
                aria-label="Limpiar filtros"
                style={{ color: '#000' }}
              >
                <FaTrash />
              </Button>
            )}
          </div>
          {error && (
            <Alert variant="danger" className="mt-2 mb-0" style={{ fontSize: '0.875rem' }}>
              {error}
            </Alert>
          )}
        </Col>
        <Col xs={12} md={6}>
          <Card className="shadow-sm h-100 admin-card admin-card-sales">
            <Card.Body>
              <Card.Title className="mb-1">Total de ventas</Card.Title>
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <div style={{ fontSize: '1.6rem', fontWeight: 700 }}>
                    ${totalVentas.toLocaleString()}
                  </div>
                  {cantidadPedidos > 0 && (
                    <small className="text-muted">
                      {cantidadPedidos} {cantidadPedidos === 1 ? 'pedido' : 'pedidos'}
                    </small>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card className="shadow-sm h-100 admin-card admin-card-commission">
            <Card.Body>
              <Card.Title className="mb-1">Comisión Higher</Card.Title>
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <div style={{ fontSize: '1.6rem', fontWeight: 700 }}>
                  ${comisionHigher.toLocaleString()}
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Admin;


